import { NgModule } from '@angular/core';
import { UnsavedChangesGuard } from './unsaved-changes/unsaved-changes.guard';

@NgModule({
  providers: [UnsavedChangesGuard]
})
export class CommonGuardsModule {}
